"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = gtm;
var dlFunctions = _interopRequireWildcard(require("./dataLayerFunctions"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * The plugins that connect Thor to Google Tag Manager.
 * @namespace Thor.plugins.GTM
 * @memberof Thor.plugins
 * @class
 */
function gtm(Thor) {
  if (typeof window === "undefined") return;
  var _dl = window.dataLayer = window.dataLayer || [],
    _pushVariable = function _pushVariable(obj) {
      _dl.push(obj);
    },
    _pushEvent = function _pushEvent(evt) {
      _dl.push({
        event: evt
      });
    };
  Thor.addVariablesListener(_pushVariable);
  Thor.addEventsListener(_pushEvent);
  return {
    /**
     * dataLayer of GTM. </br>
     * That is the array who's the interface between the site and GTM.
     * @memberof Thor.plugins.GTM
     * @member {Object} dataLayer
     */
    dataLayer: _dl,
    /**
     * Get the dataLayer value of a given key.
     * @method
     * @name Thor.plugins.GTM.getDataLayerValue
     * @param {String} key - The key to find into the thor's dataLayer
     * @param {Array|Object} [dl=dataLayer] - The context to launch the search, by default the plugin's dataLayer
     * @return {*} Return the value that matches the key, default value is an empty string.
     */
    getDataLayerValue: function getDataLayerValue(key) {
      var dl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _dl;
      return dlFunctions.getDataLayerValue(dl, key);
    },
    /**
     * Return the list on the dataLayer, matching the key passed in params.
     * @method
     * @name Thor.plugins.GTM.getDataLayerListById
     * @param {String} key - The key to find into the dataLayer
     * @param {Array|Object} [dl=dataLayer] - The context to launch the search, by default the plugin's dataLayer
     * @return {Array} Return the value that matches the key, default value is an empty array.
     */
    getDataLayerListById: function getDataLayerListById(key) {
      var dl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _dl;
      return dlFunctions.getDataLayerListById(dl, key);
    },
    /**
     * Return the object on the dataLayer, matching the combo
     * key:value passed in params.
     * @method
     * @name Thor.plugins.GTM.getDataLayerObject
     * @param {String} key - Name of the key in the thor's dataLayer
     * @param {String} val - Value to test with the key's name
     * @param {Array|Object} [dl=dataLayer] - The context to launch the search, by default the plugin's dataLayer
     * @return {Object}
     * Return the object of the dataLayer matching the combo key:value,
     * else return false.
     */
    getDataLayerObject: function getDataLayerObject(key, val) {
      var dl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _dl;
      return dlFunctions.getDataLayerObject(dl, key, val);
    },
    /**
     * Check if an element exist in the dataLayer.
     * @method
     * @name Thor.plugins.GTM.inDataLayer
     * @param {String} key - Name of the key in the thor's dataLayer
     * @param {String} val - Value to test with the key's name
     * @param {Array|Object} [dl=dataLayer] - The context to launch the search, by default the
     * @return {Boolean}
     * Return True if the combo key: value exist in the dataLayer array,
     * else return false.
     */
    inDataLayer: function inDataLayer(key, val) {
      var dl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _dl;
      return dlFunctions.inDataLayer(dl, key, val);
    },
    /**
     * Push a non event object into the dataLayer.
     * @method
     * @name Thor.plugins.GTM.pushVariable
     * @param {Object} obj - The oject to add into the dataLayer
     */
    pushVariable: _pushVariable,
    /**
     * Push an event into the dataLayer, with an optional object to add into the dataLayer.
     * @method
     * @name Thor.plugins.GTM.pushEvent
     * @param {String} evt - The event to launch.
     */
    pushEvent: _pushEvent
  };
}
;